<template>
  <div v-if="showModal && fileUrl && fileUrl !== ''" class="modal-backdrop" @click.self="closeModal">
    <div class="modal-content">
      <div class="close-btn-container">
        <button
          class="cursor-pointer p-3 text-base text-base-content-300 w-7 h-7 flex items-center justify-center rounded-full text-center"
          @click="closeModal"
        >
          <font-awesome-icon icon="times" class="cursor-pointer text-lg" />
        </button>
      </div>
      <div class="file-container">
        <iframe
          v-if="viewerUrl"
          :src="viewerUrl"
          frameborder="0"
          class="file-iframe"
        ></iframe>
        <p v-else>Unsupported file format or error loading file.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileViewerModal",
  props: {
    fileUrl: {
      type: String,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    viewerUrl() {
      if (this.fileUrl && this.fileUrl !== "") {
        const extension = this.fileUrl.split('.').pop().toLowerCase();
        // const isGoogleViewable = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'csv'].includes(extension);
  
        if (extension === 'pdf') {
          return this.fileUrl;
        } else { //  if (isGoogleViewable)
          return `https://docs.google.com/gview?url=${encodeURIComponent(this.fileUrl)}&embedded=true`;
        }
      }

      return null;
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.411);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	opacity: 1!important;
}
.modal-content {
	background: white;
	width: 60%;
	height: 80%;
	position: relative;
	border-radius: 8px;
	overflow: hidden;
}
.close-btn-container {
	position: absolute;
	top: 1rem;
	left: 1rem;
	background-color: #fff;
	border-radius: 50%;
}
.file-iframe {
	width: 60vw;
	height: 80vh;
}
</style>
